export default __webpack_public_path__ + "static/media/assessment.e45867b1.svg";